// Prefix on a bookAppointment FORBIDDEN message that marks a known-data eligibility rejection, as
// opposed to a program-access denial (assertProgramEnabled also throws FORBIDDEN, without a reason).
// The client keys on this to route only eligibility rejections to the not-eligible screen and to
// recover the exclusion reason id from the message. Shared here so the two sides can't drift. (MEM-771)
export const BOOKING_INELIGIBLE_ERROR_PREFIX = "booking_ineligible:"
